import { object } from "prop-types";
import { useTranslation } from "react-i18next";

export const McpSsoStatus = ({ access }) => {
  const {t} = useTranslation();
  const level = access?.accessLevel || t("views.team.mcp_sso.level_none");
  const status = access?.status || "revoked";

  return (
    <div>
      <strong>{level}</strong>
      <p className="text-xs">{t(`views.team.mcp_sso.status.${status}`)}</p>
    </div>
  );
};

McpSsoStatus.propTypes = {
  access: object,
};
